import React, { useState } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import  Index  from "views/seller/Index";
import CleanNavbar from "components/Navbars/CleanNavbar";
import SellerSidebar from "components/Sidebar/SellerSidebar";
import imgtoData from "../../variables/imgManipulation";
import { getProfileInfo } from "../../network/ApiAxios";
import UserProfile from "views/user/userProfile";
import EditProfile from "views/examples/EditProfile";
import Events from 'views/examples/ticketing/Events'
import Cart from 'views/examples/ticketing/EventsCart'

import CheckPermission from "variables/CheckPermission";
import NewPass from "components/Reusable Components/NewPass";
import EventsMedia from "views/examples/ticketing/EventsMedia";
import { Row } from "reactstrap";

const User = () => {
  const history = useHistory();
  const [pic, setpic] = useState();
  const [permission, setPermission] = useState(true);
  
  const permisson = CheckPermission()
      if(!permisson){
        setPermission(false)
      }
      
  let user;
  user = JSON.parse(localStorage.getItem("user"));
  const role = JSON.parse(localStorage.getItem("user")).role;

  // eslint-disable-next-line
  const getProfilePic = async () => {
    const data = await getProfileInfo(user.userID);
    if (data.data.data) {
      const dat = data.data.data;
      setpic(imgtoData(dat));
    } else {
      setpic(require("../../assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  let Comp;
  let title;
  let path = history.location.pathname;
  // eslint-disable-next-line
  switch(path){
      case "/seller/profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/seller/index":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/seller":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/seller/profile/edit":
        Comp=EditProfile;
        title='Edit Profile';
        break;  
      case "/seller/events":
        Comp=Events;
        title='Events';
        break; 
      case "/seller/newpass":
        Comp=NewPass;
        title='Events';
        break; 
      case "/seller/events/cart":
        Comp=Cart;
        title='Cart';
        break;
      case "/seller/events/media":
        Comp=EventsMedia;
        title='Media';
        break;
  }



  return permission ? <>
              <SellerSidebar
              pic={pic}
              logo={{
                innerLink: "/" + role + "/index",
                imgSrc: require("../../assets/img/brand/argon-react.png").default,
                imgAlt: "..."
              }}/>
              <div className="main-content">
                <CleanNavbar title={title}  />
                <Row className="mb-4"></Row>
                <Route
                component={Comp}
                />
              </div>
          </>: <Redirect to='/' />;
};

export default User;
